<div class="modal-header">
  <button
    type="button"
    (click)="dismiss()"
    class="btn-close"
    title="Close"></button>
  <h3 class="modal-title">Export Ideation Data - Step {{ modal.step }}/4</h3>
</div>
<div *ngIf="modal.step === 1">
  <div class="modal-body clearfix">
    <div class="col-lg-12">
      <h4>Options</h4>
      <div class="checkbox">
        <label>
          <input type="checkbox" [(ngModel)]="exportVotes" />
          Export Ratings
        </label>
      </div>
      <div class="checkbox">
        <label>
          <input type="checkbox" [(ngModel)]="exportComments" />
          Export Comments
        </label>
      </div>
    </div>
  </div>
</div>
<div *ngIf="modal.step === 2">
  <div class="modal-body clearfix">
    <div class="col-lg-12">
      <h4>Select Ideas To Export</h4>
      <a (click)="selectAll(sessionExportData.data.ideas)">all</a>
      &nbsp;
      <a (click)="deselectAll(sessionExportData.data.ideas)">none</a>
      <ul class="entity-list">
        <li *ngFor="let idea of ideas">
          <label class="form-label" for>
            <input type="checkbox" [(ngModel)]="idea.selected" />
            {{ idea.title }}
          </label>
        </li>
      </ul>
    </div>
  </div>
</div>
<div *ngIf="modal.step === 3">
  <div class="modal-body clearfix">
    <div class="col-lg-12">
      <h4>Select Participants To Export</h4>
      <a (click)="selectAll(sessionExportData.config.participants)">all</a>
      &nbsp;
      <a (click)="deselectAll(sessionExportData.config.participants)">none</a>
      <ul class="entity-list">
        <li *ngFor="let participant of participants">
          <label class="form-label" for>
            <input type="checkbox" [(ngModel)]="participant.selected" />
            {{
              !participant.user ||
              !participant.user.name ||
              participant.user.name === 'Not registered yet'
                ? participant.user && participant.user.email
                  ? participant.user.email.split('@')[0]
                  : 'Reload for Email'
                : participant.user
                  ? participant.user.name
                  : ''
            }}
          </label>
        </li>
      </ul>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button
    *ngIf="modal.step !== 1"
    (click)="modal.step = modal.step - 1"
    class="btn btn-primary pull-left">
    Back
  </button>
  <button
    *ngIf="modal.step !== 3"
    (click)="modal.step = modal.step + 1"
    class="btn btn-primary">
    Next
  </button>
  <button *ngIf="modal.step === 3" (click)="export()" class="btn btn-primary">
    Export
  </button>
  <button (click)="dismiss()" class="btn btn-danger">Cancel</button>
</div>
